(function () {
  /* Judge.me "Write a review" pop-up tweaks:
     1. A 3-step progress bar (Rating, Your review, About you), and a Next button on the rating step.
     2. Photo/video upload moved onto the "Your review" step, so the last step submits straight away.
     3. Closing mid-review asks for confirmation first. */
  var P = 'jdgm-write-review-modal__';
  var STEPS = ['Rating', 'Your review', 'About you'];
  var PAGE_STEP = { 'review-form-intro': 0, 'review-details': 1, 'about-you': 2, 'share-media': 2, 'thank-you': 3 };

  function q(root, cls) { return root.querySelector('.' + P + cls); }

  function currentKey(modal) {
    var cur = modal.querySelector('.' + P + 'page.current-page');
    if (!cur) return null;
    var m = cur.className.match(new RegExp(P + 'page--([a-z-]+)'));
    return m ? m[1] : null;
  }

  function moveMedia(modal) {
    var group = q(modal, 'form-group--share-media');
    var details = modal.querySelector('.' + P + 'page--review-details .' + P + 'form');
    if (!group || !details || details.contains(group)) return;
    var after = q(details, 'form-group--review-content');
    if (after) after.after(group); else details.appendChild(group);
    modal.classList.add('fvjm-media-moved');
  }

  function buildStepper(modal) {
    var content = q(modal, 'content');
    if (!content || content.querySelector('.fvjm-steps')) return;
    var wrap = document.createElement('div');
    wrap.className = 'fvjm-steps';
    wrap.setAttribute('aria-hidden', 'true');
    var html = '<div class="fvjm-steps__bar"><span class="fvjm-steps__fill"></span></div><ol class="fvjm-steps__list">';
    STEPS.forEach(function (s, i) { html += '<li class="fvjm-steps__item" data-i="' + i + '"><span class="fvjm-steps__dot">' + (i + 1) + '</span><span class="fvjm-steps__label">' + s + '</span></li>'; });
    wrap.innerHTML = html + '</ol>';
    var close = q(content, 'close-btn');
    if (close) close.after(wrap); else content.prepend(wrap);
  }


  /* Rating step: clicking a star only selects it; the new Next button moves on. */
  function introStars(modal) { return Array.prototype.slice.call(modal.querySelectorAll('.' + P + 'page--review-form-intro .jdgm-star')); }
  function paintIntro(modal) {
    var sel = modal.__fvjmSel == null ? -1 : modal.__fvjmSel;
    introStars(modal).forEach(function (s, i) {
      s.classList.toggle('jdgm--on', i <= sel);
      s.classList.toggle('jdgm--off', i > sel);
    });
  }
  function setupIntro(modal) {
    var page = q(modal, 'page--review-form-intro');
    if (!page || page.querySelector('.fvjm-intro-nav')) return;
    var nav = document.createElement('div');
    nav.className = 'fvjm-intro-nav';
    nav.innerHTML = '<button type="button" class="fvjm-next" disabled>Next</button>';
    page.appendChild(nav);
    var btn = nav.querySelector('button');
    if (modal.__fvjmSel != null) btn.disabled = false;
    btn.addEventListener('click', function () {
      var stars = introStars(modal);
      if (modal.__fvjmSel == null || !stars[modal.__fvjmSel]) return;
      modal.__fvjmPass = true;
      stars[modal.__fvjmSel].click();
      modal.__fvjmPass = false;
    });
    var row = q(page, 'stars');
    if (row) row.addEventListener('mouseleave', function () { setTimeout(function () { paintIntro(modal); }, 0); });
  }


  /* Close button: ask before throwing away a review in progress. */
  function isOpen(modal) { return modal.isConnected && getComputedStyle(modal).display !== 'none'; }
  function needsConfirm(modal) {
    var key = currentKey(modal);
    if (key === 'review-details' || key === 'about-you') return true;
    if (key === 'review-form-intro') return modal.__fvjmSel != null;
    return false;
  }
  function hideConfirm(modal) {
    var box = modal.querySelector('.fvjm-confirm');
    if (box) box.classList.remove('is-open');
  }
  function reallyClose(modal) {
    hideConfirm(modal);
    modal.__fvjmSel = null;
    paintIntro(modal);
    var next = modal.querySelector('.fvjm-next');
    if (next) next.disabled = true;
    var btn = q(modal, 'close-btn');
    if (btn) { modal.__fvjmClosePass = true; btn.click(); modal.__fvjmClosePass = false; }
  }
  function showConfirm(modal) {
    var content = q(modal, 'content');
    if (!content) return;
    var box = content.querySelector('.fvjm-confirm');
    if (!box) {
      box = document.createElement('div');
      box.className = 'fvjm-confirm';
      box.setAttribute('role', 'alertdialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-labelledby', 'fvjm-confirm-title');
      box.innerHTML = '<div class="fvjm-confirm__card">' +
        '<span class="fvjm-confirm__icon" aria-hidden="true">!</span>' +
        '<p class="fvjm-confirm__title" id="fvjm-confirm-title">Leave without posting?</p>' +
        '<p class="fvjm-confirm__text">Your rating and review haven’t been sent yet. If you close now, they’ll be lost.</p>' +
        '<div class="fvjm-confirm__btns">' +
        '<button type="button" class="fvjm-confirm__leave">Yes, close</button>' +
        '<button type="button" class="fvjm-confirm__stay">Keep writing</button>' +
        '</div></div>';
      content.appendChild(box);
      box.querySelector('.fvjm-confirm__stay').addEventListener('click', function () { hideConfirm(modal); });
      box.querySelector('.fvjm-confirm__leave').addEventListener('click', function () { reallyClose(modal); });
    }
    box.classList.add('is-open');
    setTimeout(function () { var s = box.querySelector('.fvjm-confirm__stay'); if (s) s.focus(); }, 30);
  }

  var autoSubmitted = false;
  function update(modal) {
    moveMedia(modal);
    buildStepper(modal);
    setupIntro(modal);
    var key = currentKey(modal);
    var step = key in PAGE_STEP ? PAGE_STEP[key] : 0;
    modal.setAttribute('data-fvjm-page', key || '');
    /* Hide the upload overlay once a photo reaches 100% */
    modal.querySelectorAll('.' + P + 'spinner-wrapper').forEach(function (w) {
      w.classList.toggle('fvjm-done', w.textContent.trim() === '100%');
    });
    var wrap = modal.querySelector('.fvjm-steps');
    if (wrap) {
      wrap.querySelectorAll('.fvjm-steps__item').forEach(function (li, i) {
        li.classList.toggle('is-done', i < step);
        li.classList.toggle('is-current', i === step);
      });
      var fill = wrap.querySelector('.fvjm-steps__fill');
      if (fill) fill.style.width = Math.min(100, (step / (STEPS.length - 1)) * 100) + '%';
    }
    /* The photo step is now empty, so submit it for the customer as soon as it opens. */
    if (key === 'share-media' && modal.classList.contains('fvjm-media-moved')) {
      if (!autoSubmitted) {
        autoSubmitted = true;
        setTimeout(function () {
          var btn = q(modal, 'nav-btn-next');
          if (btn) btn.click();
        }, 350);
      }
    } else if (key !== 'thank-you') {
      autoSubmitted = false;
    }
  }

  function watch(modal) {
    if (modal.__fvjm) return;
    modal.__fvjm = true;
    modal.addEventListener('click', function (e) {
      if (modal.__fvjmClosePass) return;
      var closeBtn = e.target.closest && e.target.closest('.' + P + 'close-btn');
      var outside = e.target === q(modal, 'overlay') || e.target === q(modal, 'container');
      if ((closeBtn || outside) && needsConfirm(modal)) {
        e.stopPropagation();
        e.preventDefault();
        showConfirm(modal);
      }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen(modal)) return;
      var box = modal.querySelector('.fvjm-confirm.is-open');
      if (box) { e.stopPropagation(); e.preventDefault(); hideConfirm(modal); return; }
      if (needsConfirm(modal)) { e.stopPropagation(); e.preventDefault(); showConfirm(modal); }
    }, true);
    modal.addEventListener('click', function (e) {
      var star = e.target.closest && e.target.closest('.' + P + 'page--review-form-intro .jdgm-star');
      if (!star || modal.__fvjmPass) return;
      e.stopPropagation();
      e.preventDefault();
      modal.__fvjmSel = introStars(modal).indexOf(star);
      paintIntro(modal);
      var btn = modal.querySelector('.fvjm-next');
      if (btn) btn.disabled = false;
    }, true);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; update(modal); }, 30);
    }).observe(modal, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'], characterData: true });
    update(modal);
  }

  function scan() {
    document.querySelectorAll('.jdgm-write-review-modal').forEach(watch);
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true });
})();
